module.exports = __webpack_public_path__ + "img/sql.2e38e0e9.png";